import { createElement as rc, useContext } from 'react';
import * as reactMenu from '@szhsin/react-menu';
import { ModalContext } from '../../contexts';
import './styles';

export default function Menu(props) {
    const { children, ...otherProps } = props;
    const { isInsideModal } = useContext(ModalContext);

    const portalTarget = (function() {
        if (typeof document === 'undefined') return undefined;
        // If we are explicitly inside a modal via context, use the dialog portal target
        if (isInsideModal) {
            return document.querySelector('dialog') || document.body;
        }
        return document.body;
    })();

    if (otherProps.menuButton == null) {
        // TODO: replace with react-props
        throw new Error('A menuButton prop containing a component must be passed into the Menu primitive.');
    }
    return rc(reactMenu.Menu, { portal: { target: portalTarget }, ...otherProps }, children);
}
